module.exports = __webpack_public_path__ + "static/media/register.e09819d2.jpg";